import {
  IconLayoutDashboard,
  IconPlugConnected,
  IconSquarePlus,
  IconFileImport,
  IconListDetails,
  IconStack2,
  IconCircleX,
  IconLock,
  IconRotate360,
  IconSend,
  IconReceiptRefund,
  IconCreditCard,
  IconCashBanknote,
  IconBook,
  IconReceiptTax,
  IconCertificate,
  IconArrowsExchange,
  IconId,
  IconCoin,
} from "@tabler/icons";
import { getRoleId } from "./session";

// The sidebar menu per role. Every `to` is a route in routes/MainRoutes.js.
// `match` lists other paths that keep the item highlighted (its sub pages).

export const ORDER_ADMIN_NAV = [
  {
    title: "Overview",
    items: [{ label: "Dashboard", to: "/order-dashboard", icon: IconLayoutDashboard }],
  },
  {
    title: "Punching",
    items: [
      { label: "PRF Connect", to: "/prfConnect", icon: IconPlugConnected },
      { label: "Create order", to: "/create-order", icon: IconSquarePlus },
      { label: "Import CSV", to: "/insertOrder", icon: IconFileImport, match: ["/tempOrder", "/view-temp-order-details"] },
    ],
  },
  {
    title: "Orders",
    items: [
      { label: "Order report", to: "/orders-table", icon: IconListDetails, match: ["/edit-order"] },
      { label: "Bulk update", to: "/bulk-orderUpdate", icon: IconStack2 },
      { label: "Cancelled", to: "/cancelled-orders", icon: IconCircleX, match: ["/edit-cancelled-order"] },
      { label: "Holds", to: "/order-holds", icon: IconLock },
      { label: "Order 360", to: "/order-360", icon: IconRotate360 },
    ],
  },
];

export const PAYMENT_ADMIN_NAV = [
  {
    title: "Overview",
    items: [{ label: "Dashboard", to: "/payment-dashboard", icon: IconLayoutDashboard }],
  },
  {
    title: "Payouts",
    items: [
      { label: "Payout runs", to: "/payout-runs", icon: IconSend, match: ["/payout-runs/new", "/payout-run"] },
      { label: "Redeem requests", to: "/redeem-requests", icon: IconReceiptRefund },
      { label: "Payments", to: "/payment-table", icon: IconCreditCard, match: ["/payment-edit"] },
      { label: "Manual payouts", to: "/payout", icon: IconCashBanknote, match: ["/create-payout"] },
    ],
  },
  {
    title: "Ledger",
    items: [
      { label: "Ledgers", to: "/payment-ledger", icon: IconBook },
      { label: "DealCoins", to: "/dealcoins", icon: IconCoin },
      { label: "Holds", to: "/payment-holds", icon: IconLock },
      { label: "Order 360", to: "/order-360", icon: IconRotate360 },
    ],
  },
  {
    title: "Tax",
    items: [
      { label: "TDS register", to: "/tds-register", icon: IconReceiptTax },
      { label: "TDS certificates", to: "/tds-certificates", icon: IconCertificate },
    ],
  },
  {
    title: "Reports",
    items: [
      { label: "Order report", to: "/orders-table", icon: IconListDetails, match: ["/edit-order-payment-admin"] },
      { label: "Paid transactions", to: "/payment-transactions", icon: IconArrowsExchange },
      { label: "Payment details", to: "/paymentDetails", icon: IconId, match: ["/edit-paymentDetails"] },
    ],
  },
];

export const SUPER_ADMIN_NAV = [
  {
    title: "Reports",
    items: [
      { label: "Order report", to: "/orders-table", icon: IconListDetails },
      { label: "Payment details", to: "/paymentDetails", icon: IconId, match: ["/edit-paymentDetails"] },
      { label: "Credit limits", to: "/credit", icon: IconCoin, match: ["/update-payment"] },
    ],
  },
];

export function navFor(roleId = getRoleId()) {
  switch (Number(roleId)) {
    case 5:
    case 8:
      return ORDER_ADMIN_NAV;
    case 7:
      return PAYMENT_ADMIN_NAV;
    case 6:
      return SUPER_ADMIN_NAV;
    default:
      return [];
  }
}

export const isNavActive = (item, pathname) => item.to === pathname || (item.match || []).includes(pathname);

// Header titles for routes that are not menu items: [section, title].
export const ROUTE_TITLES = {
  "/edit-order": ["Orders", "Edit order"],
  "/edit-cancelled-order": ["Orders", "Edit cancelled order"],
  "/tempOrder": ["Punching", "CSV batches"],
  "/view-temp-order-details": ["Punching", "CSV batch details"],
  "/payout-runs/new": ["Payouts", "New payout run"],
  "/payout-run": ["Payouts", "Payout run"],
  "/payment-edit": ["Payouts", "Payment details"],
  "/create-payout": ["Payouts", "New manual payout"],
  "/edit-order-payment-admin": ["Reports", "Update order status"],
  "/edit-paymentDetails": ["Reports", "Edit payment details"],
  "/update-payment": ["Reports", "Update credit limit"],
  "/export-table": ["CRM", "Export"],
  "/assign-lead": ["CRM", "Assign lead"],
  "/users": ["CRM", "Users"],
  "/edituser": ["CRM", "Edit user"],
  "/leadform": ["CRM", "Lead form"],
  "/editlead": ["CRM", "Edit lead"],
  "/call-summary": ["CRM", "Call summary"],
};

// { section, title } for the header and the document title.
export function pageMeta(pathname, roleId = getRoleId()) {
  const sections = navFor(roleId);
  for (const s of sections) {
    const hit = s.items.find((it) => it.to === pathname);
    if (hit) return { section: s.title, title: hit.label };
  }
  if (ROUTE_TITLES[pathname]) return { section: ROUTE_TITLES[pathname][0], title: ROUTE_TITLES[pathname][1] };
  for (const s of sections) {
    const hit = s.items.find((it) => isNavActive(it, pathname));
    if (hit) return { section: s.title, title: hit.label };
  }
  return { section: "", title: "" };
}
